// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-upload[data-v-3f71a6fb] {\n  margin: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px)) auto;\n  --magic-box-padding: 0;\n}\n\n.header[data-v-3f71a6fb] {\n  margin: 0;\n  color: var(--magic-text-dark, #1d2939);\n}\n\n.files[data-v-3f71a6fb] {\n  background-color: var(--magic-highlight, #f3f1fc);\n}\n\n.content[data-v-3f71a6fb] {\n  padding: 0 var(--magic-space, 16px) var(--magic-space, 16px);\n}", ""]);
// Exports
module.exports = exports;
